import {timeFormat, numberFormat} from "@custom/index";
import {conversionAmount} from "@/utils/hooks";
// 问卷设计 tableColumn
export const tableColumn = [
    {
        type: "index",
        label: "序号",
        width: 60,
        className: 'column-tree',
    },
    {
        prop: "title",
        label: "名称",
        width: 600,
        className: 'column-tree',
    },
    {
        prop: "communityName",
        label: "生效范围",
        width: 300,
        // className: 'column-tree',
    },
    // {
    //     prop: "type",
    //     label: "建筑类型",
    //     width: 100,
    //     render: (h, { row }) => {
    //         const { label } = architectureType.find(v => v.value === row.type);
    //         return h("span", label);
    //     }
    // },
    {
        prop: "statusName",
        label: "状态",
        width: 200,
    },
    {
        prop: "comment",
        label: "备注",
        width: 300,
    },
    // {
    //     prop: "layerMax",
    //     label: "最大楼层数",
    //     width: 100,
    // },
    // {
    //     prop: "address",
    //     label: "地址",
    // },
    // {
    //     prop: "apartmentsCount",
    //     label: "房源总数",
    //     width: 100
    // },
    // /*{
    //     prop: "boundCount",
    //     label: "绑定房源数",
    //     width: 100
    // },*/
    // {
    //     prop: "rentingCount",
    //     label: "已租房源数",
    //     width: 100
    // },
    // {
    //     prop: "vacantCount",
    //     label: "空闲房源总数",
    //     width: 100
    // },
    // {
    //     prop: "houseManageName",
    //     label: "管家姓名",
    //     width: 100
    // },
    // {
    //     prop: "houseManagePhone",
    //     label: "管家手机号",
    //     width: 100
    // },
];
// 问卷收集 LeasortableColumn
export const LeasortableColumn = [
    {
        type: "index",
        label: "序号",
        width: 60,
    },
    {
        prop: "contractNum",
        label: "合同编号",
        width: 200,
    },
    {
        prop: "startTime",
        label: "合同开始时间",
        render: (h, { row }) => {
            const startTime = !row.startTime ? "" : timeFormat(new Date(Number(row.startTime)), 'yyyy-MM-dd HH:mm:ss');
            return h("span", startTime);
        }
    },  
    {
        prop: "leasorName",
        label: "租户名称",
        width: 200,
    },
    {
        prop: "apartmentName",
        label: "房源名称",
        width: 400,
    },
    {
        prop: "createTime",
        label: "提交时间",
        render: (h, { row }) => {
            const createTime = !row.createTime ? "" : timeFormat(new Date(Number(row.createTime)), 'yyyy-MM-dd HH:mm:ss');
            return h("span", createTime);
        }
    },    
];
